export const COMING_SOON = 'COMING_SOON';
export const AVAILABLE_PREWIRED = 'AVAILABLE_PREWIRED';
export const AVAILABLE_NOT_PREWIRED = 'AVAILABLE_NOT_PREWIRED';
export const NOT_AVAILABLE = 'NOT_AVAILABLE';
export const UNAVAILABLE = 'UNAVAILABLE';



// WEBPACK FOOTER //
// ./src/data/status.js